import React from 'react';
import { XCircle } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Problema() {
  const revealRef = useScrollReveal();
  const gridRef = useScrollReveal();
  return <section id="problema" className="bg-carbon py-14 sm:py-[90px] px-6" data-id="element-305">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-306">
        <div className="text-center" data-id="element-307">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-308">
            El problema que nadie nombra
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-309">
            La pasta sin gluten del mercado
            <br data-id="element-310" />
            es, francamente, un insulto.
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-311"></div>
          <p className="text-[15px] text-white/60 max-w-[620px] mx-auto leading-[1.8]" data-id="element-312">
            No es tu culpa que hayas probado 12 marcas y ninguna funcione. El
            problema no es tu paladar. Es que esas pastas fueron diseñadas para
            sobrevivir en un estante, no para satisfacerte en la mesa.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-14 stagger-children" data-id="element-313">
          <div className="bg-gris-oscuro border-l-[3px] border-rojo-acento p-7 pl-8 rounded-sm" data-id="element-314">
            <h3 className="font-montserrat text-[16px] font-bold mb-2.5 text-white flex items-center gap-2" data-id="element-315">
              <XCircle className="text-rojo-acento" size={18} data-id="element-316" /> Se deshace al
              cocinarla
            </h3>
            <p className="text-[14px] text-white/65 leading-[1.7]" data-id="element-317">
              Intentas hacer un plato presentable y terminas con una sopa de
              migajas. La textura se destruye a los 8 minutos de cocción.
            </p>
          </div>
          <div className="bg-gris-oscuro border-l-[3px] border-rojo-acento p-7 pl-8 rounded-sm" data-id="element-318">
            <h3 className="font-montserrat text-[16px] font-bold mb-2.5 text-white flex items-center gap-2" data-id="element-319">
              <XCircle className="text-rojo-acento" size={18} data-id="element-320" /> Sabor a cartón
              con salsa encima
            </h3>
            <p className="text-[14px] text-white/65 leading-[1.7]" data-id="element-321">
              El relleno o la salsa tapan el problema momentáneamente, pero en
              boca sabes que algo está mal. Tu familia también lo nota.
            </p>
          </div>
          <div className="bg-gris-oscuro border-l-[3px] border-rojo-acento p-7 pl-8 rounded-sm" data-id="element-322">
            <h3 className="font-montserrat text-[16px] font-bold mb-2.5 text-white flex items-center gap-2" data-id="element-323">
              <XCircle className="text-rojo-acento" size={18} data-id="element-324" /> Precio
              desorbitado, resultado mediocre
            </h3>
            <p className="text-[14px] text-white/65 leading-[1.7]" data-id="element-325">
              Pagas el doble o triple por algo que ni satisface. El mercado "sin
              gluten" cobra prima de culpa, no de calidad.
            </p>
          </div>
          <div className="bg-gris-oscuro border-l-[3px] border-rojo-acento p-7 pl-8 rounded-sm" data-id="element-326">
            <h3 className="font-montserrat text-[16px] font-bold mb-2.5 text-white flex items-center gap-2" data-id="element-327">
              <XCircle className="text-rojo-acento" size={18} data-id="element-328" /> Recetas online
              que simplemente no funcionan
            </h3>
            <p className="text-[14px] text-white/65 leading-[1.7]" data-id="element-329">
              Probaste YouTube, blogs, grupos de Facebook. Algunas recetas ni
              siquiera probaron lo que enseñan. El fracaso se repite.
            </p>
          </div>
        </div>

        <div className="mt-14 text-center" data-id="element-330">
          <img src="https://i.postimg.cc/KjHJV9G4/g-Vb-8hee-IGs67-RAVGg-Cf-O-1-min.png" alt="Pasta sin gluten de mala calidad" className="w-full max-w-[520px] h-auto object-contain rounded-md opacity-85 grayscale-[20%] mx-auto" data-id="element-331" />
          <p className="text-[12px] text-white/30 mt-3 text-center" data-id="element-332">
            Esto es lo que el mercado ofrece. No tiene que ser así.
          </p>
        </div>
      </div>
    </section>;
}